import { customTextBlock, paragraph, heading } from "../../../text/nodes"
import { Testimonial as TestimonialEditor } from "./testimonial"
import { TestimonialSettings } from "./testimonial-settings"
import TestimonialPreview from "./testimonial-preview.png"
import { getFont } from "../../../shared/fonts"

export const Testimonial = {
  name: "testimonial",
  label: "image on left, testimonial right",
  EditorComponent: TestimonialEditor,
  SettingsComponent: TestimonialSettings,
  image: TestimonialPreview,
  defaultProperties: {
    backgroundColor: "#ffffff",
    quoteColor: "#4d4d4d",
    quoteFontFamily: getFont("Times New Roman"),
    headingColor: "#4d4d4d",
    headingFontFamily: getFont("Verdana"),
    textFontFamily: getFont("Verdana"),
    headingFontWeight: 400,
    nameColor: "#4d4d4d",
    image: "",
    alt: "",
    horizontalPadding: 0,
    verticalPadding: 0,
    marginTop: 24,
    marginBottom: 24,
    borderTopLeftRadius: 0,
    borderTopRightRadius: 0,
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0,
    imageBorderRadius: 0,
    columnRatio: 40,
    borderColor: "#e3e3e3",
    borderTopWidth: 1,
    borderRightWidth: 1,
    borderBottomWidth: 1,
    borderLeftWidth: 1
  },
  defaultChildren: [
    customTextBlock([
      heading(
        "three",
        "Lorem ipsum dolor sit amet, consectetur adipiscing elit."
      )
    ]),
    customTextBlock([paragraph("Name")])
  ]
}
